import { render, staticRenderFns } from "./ProductDetailsSimplified.vue?vue&type=template&id=3bd9ccb1"
import script from "./ProductDetailsSimplified.vue?vue&type=script&lang=js"
export * from "./ProductDetailsSimplified.vue?vue&type=script&lang=js"
import style0 from "./scss/product-details-simplified.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd9ccb1')) {
      api.createRecord('3bd9ccb1', component.options)
    } else {
      api.reload('3bd9ccb1', component.options)
    }
    module.hot.accept("./ProductDetailsSimplified.vue?vue&type=template&id=3bd9ccb1", function () {
      api.rerender('3bd9ccb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/greenmotion-shared/Components/quotes/ProductDetailsSimplified.vue"
export default component.exports